module.exports = __webpack_public_path__ + "img/rob_logistics.9823e995.png";